<div data-testId="price-sort-helper-text">
  When sorting by price, prices may vary based on product size. For best results, apply a size
  filter.
</div>
